export default __webpack_public_path__ + "23bccb87ca32c179069c8b7b06ecc2d5.svg";